import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function Updates2026Page() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-2026-updates")!;
  return <ArticleLayout article={article} />;
}